<template>
  <div class="pt-5 position-relative view-wrapper">
		<div class="product-instructions">
			<LocalizedLink to="/"  class="close-detail position-absolute"></LocalizedLink>

			<arrow arrow-class="arrow-left" target="/diner"></arrow>
			<arrow arrow-class="arrow-right" target="/slide"></arrow>
      <div class="p-border">
        <div class="product-copy-container">
          <div class="product-title" v-html="$t('rooftop_screen.title')">
          </div>
          <div class="product-inst" v-html="$t('rooftop_screen.content')"></div>
        </div>
      </div>

		</div>

		<div ref="product" class="product-detail position-absolute">
      <div class="product-blur-bottom"></div>
		</div>
    <div ref="tooltip" class="tooltip-b" v-html="$t('rooftop_screen.speech_bubble')"></div>

  </div>
</template>

<script>
import Arrow from "../Arrow";
import LocalizedLink from '@/components/LocalizedLink'

export default {
  name: "RooftopPage",
  components: {
		Arrow,
		LocalizedLink
	},
  data() {
    return {
      show: true
    }
  },
  mounted() {
    this.panBackground(this.$refs.product, 95);
    this.floatTooltip(this.$refs.tooltip);
  },
  methods: {
  }  
}
</script>

<style lang="scss" scoped>
.product-blur-bottom {
  position: absolute;
  top: 620px;
  left: 0;
  width: 100%;
  height: calc(var(--vh, 1vh) * 75);
  @media screen and (max-width: 768px) {
    @supports (backdrop-filter: none) {
    background: rgba(0, 0, 0, 0.4);
      -webkit-backdrop-filter: blur(4px);
      backdrop-filter: blur(4px);  
    }
  }
}

.detail-view{ 
  .product-detail {
    background-position: -280px 325px;
    @media (min-width: 729px) {
      background-position: -60px 775px;
    }
  }
}

.tooltip-b {
  width: 150px;
  padding: 12px 10px;
  background-color: #fff;
  position: absolute;
  font-family: ProximaSoft;
  font-size: 16px;
  left: 5em;
  bottom: calc(var(--vh, 1vh) * 5);
  color: #48c0ba;
  font-weight: bold;
  text-align: center;
  line-height: 18px;

  &:before {
     content: "";
     position: absolute;
     bottom: 100%;
     width: 0;
     height: 0;
    border-left: 15px solid transparent;
    border-bottom: 27px solid #fff;
    border-right: 1px solid transparent;
     right: 50px;
 }
  @media (min-width: 415px) and (max-width: 728px) {
    left: 50vw;
  }
  @media (min-width: 729px) {
    left: 43%;
  }
}

</style>
